<template>
  <div>
    <a-spin :spinning="loading">
      <a-tabs default-active-key="1" v-model="activeForm">
        <a-tab-pane v-for="group in setup" :key="group.id.toString()">
          <span slot="tab">
            <a-tooltip v-if="group.help_html">
    <template slot="title">
      Ver Ayuda
    </template>
        <a-icon type="question-circle" style="color: red" v-if="group.help_html" @click="showHelp(group)"/>
            </a-tooltip>
        {{group.name}}
      </span>
          <a-card :bordered="false" v-if="group.help_html && helpVisible['g' + group.id]">
            <a-alert message="Notas del proceso" type="info" show-icon>
              <div slot="description" v-html="group.help_html"></div>
            </a-alert>
          </a-card>
          <a-form-model :ref="`r_${group.id}_form`" :model="respuestas[`r_${group.id}`]" v-if="group.active_form">
            <a-card size="small" v-for="header in group.active_form.active_headers" :title="header.name">
              <a-row :gutter="[16,16]">
                <a-col v-bind="group.colOptions" v-for="component in header.active_components">
                  <a-form-model-item :label="component.label" :prop="component.name"
                                     :hasFeedback="component.h_component_type !== 'CHECKBOX' && component.h_component_type !== 'RADIO'"
                                     :rules="[{required: component.required, message: `El campo ${component.label} es requerido.`}]">

                    <template v-if="component.h_component_type === 'LOV_SQL'">
                      <form-model-dropdown style="width: 100%"
                                           v-model="respuestas[`r_${group.id}`][component.name]"
                                           endpoint="forms_components/sql_lov_param_values"
                                           :cache="false"
                                           :params="{...respuestas[`r_${group.id}`], id_param: component.id}">
                      </form-model-dropdown>
                    </template>

                    <template v-else-if="component.h_component_type === 'LOV_SQL_LIKE'">
                      <form-model-lookup style="width: 100%"
                                           v-model="respuestas[`r_${group.id}`][component.name]"
                                           endpoint="forms_components/sql_lov_like_param_values"
                                           :cache="false"
                                           :params="{...respuestas[`r_${group.id}`], id_param: component.id}">
                      </form-model-lookup>
                    </template>

                    <a-select v-else-if="component.h_component_type === 'LOV'"
                              v-model="respuestas[`r_${group.id}`][component.name]"
                              style="width: 100%"
                              show-search
                              placeholder="Seleccione una opción"
                    >
                      <a-select-option :value="option.value" v-for="(option, index) in component.active_options" :key="`${option.value}${index}`">
                        {{option.label}}
                      </a-select-option>
                    </a-select>
                    <a-input-number v-else-if="component.h_component_type === 'NUMBER'"
                                    v-model="respuestas[`r_${group.id}`][component.name]"
                                    style="width: 100%">
                    </a-input-number>

                    <a-date-picker v-else-if="component.h_component_type === 'DATE'"
                                   v-model="respuestas[`r_${group.id}`][component.name]"
                                   valueFormat="Y-MM-DD 00:00:00"
                                   style="width: 100%">
                    </a-date-picker>
                    <a-checkbox-group v-else-if="component.h_component_type === 'CHECKBOX'"
                                      v-model="respuestas[`r_${group.id}`][component.name]">
                      <div v-for="option in component.active_options">
                        <a-checkbox :value="option.value">
                          {{option.label}}
                        </a-checkbox>
                      </div>
                    </a-checkbox-group>
                    <a-radio-group v-else-if="component.h_component_type === 'RADIO'"
                                   v-model="respuestas[`r_${group.id}`][component.name]">
                      <div v-for="option in component.active_options">
                        <a-radio :value="option.value">
                          {{option.label}}
                        </a-radio>
                      </div>
                    </a-radio-group>
                    <a-textarea v-else-if="component.h_component_type === 'TEXTAREA'"
                                v-model="respuestas[`r_${group.id}`][component.name]"
                                auto-size>
                    </a-textarea>
                    <a-input v-else
                             v-model="respuestas[`r_${group.id}`][component.name]">
                    </a-input>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-card>
          </a-form-model>
          &nbsp;
          <a-card>
            <action-group :group="group.name"
                          :params="respuestas[`r_${group.id}`]"
                          :preValidate="validateForm"
                          @success="actualizarTabla"
                          @error="actualizarTabla"></action-group>
          </a-card>
        </a-tab-pane>
      </a-tabs>
    </a-spin>
    <a-tabs default-active-key="1">
      <a-tab-pane key="1">
      <span slot="tab">
        <a-icon type="container"/>
        Historial de Ejecuciones
      </span>
        <g-master :name="master.endpoint"
                  :endpoint="master.endpoint"
                  :actions="master.actions"
                  :tableSetup="master.tableSetup"
                  ref="masterComponent"
                  @action="masterActions"
        >
          <span slot="estadoRenderer" slot-scope="{text}">
            <a-tag v-if="text === 'PROGRAMADO'" color="blue">
              {{text}}
            </a-tag>
            <a-tag v-if="text === 'FALLIDO'" color="red">
              {{text}}
            </a-tag>
            <a-tag v-if="text === 'EN EJECUCION'" color="purple">
              {{text}}
            </a-tag>
            <a-tag v-if="text === 'FINALIZADO'" color="green">
              {{text}}
            </a-tag>
          </span>
          <span slot="peticionRender" slot-scope="{text}">
            {{recortarCadena(text)}}  <a-tooltip>
                                        <template slot="title">
                                          Ver más
                                        </template>
                                        <a-icon @click="verMas(text)" v-if="!$isEmpty(text) && text.length >= 19"
                                                type="plus-square"></a-icon>
                                      </a-tooltip>
          </span>
          <span slot="respuestaRender" slot-scope="{text}">
              {{recortarCadena(text)}} <a-tooltip>
                                        <template slot="title">
                                          Ver más
                                        </template>
                                        <a-icon @click="verMas(text)" v-if="!$isEmpty(text) && text.length >= 19"
                                                type="plus-square"></a-icon>
                                      </a-tooltip>
          </span>
          <span slot="logRender" slot-scope="{text}">
              {{recortarCadena(text)}} <a-tooltip>
                                        <template slot="title">
                                          Ver más
                                        </template>
                                        <a-icon @click="verMas(text)" v-if="!$isEmpty(text) && text.length >= 19"
                                                type="plus-square"></a-icon>
                                      </a-tooltip>
          </span>
        </g-master>
      </a-tab-pane>
    </a-tabs>
    <a-modal v-model="modalVerMas" title="Detalles" @ok="modalVerMas = false" :footer="null">
      <a-textarea readOnly v-model="contenidoVerMas" :auto-size="{ minRows: 3, maxRows: 10 }"/>
    </a-modal>
  </div>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    data () {
      return {
        loading: false,
        helpVisible: {},
        setup: {},
        respuestas: {},
        activeForm: '',
        loadingBtns: {},
        modalVerMas: false,
        contenidoVerMas: '',
        master: {
          endpoint: 'async_job_execution',
          tableSetup: {
            customSlots: ['estadoRenderer', 'peticionRender', 'respuestaRender', 'logRender'],
            actions: {
              actions: [
                {
                  name: 'reprogramar',
                  text: 'Reprogramar',
                  props: {size: 'small', type: 'link', icon: 'reload', style: 'color:green;'},
                  fnVisible: (record) => {
                    return record.estado === 'FALLIDO' || record.estado === 'FINALIZADO'
                  },
                  fnLoading: (record) => {
                    return this.loadingBtns[record.id] === record.id
                  }
                }
              ]
            },
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: '#', dataIndex: 'id', sorter: true},
              {title: 'Descripción', dataIndex: 'description', sorter: true},
              {
                title: 'Estado',
                dataIndex: 'estado',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRenderer'
                }
              },
              {title: 'Fecha inicio', dataIndex: 'start_time', sorter: true},
              {title: 'Fecha fin', dataIndex: 'end_time', sorter: true},
              {
                title: 'Petición',
                dataIndex: 'request',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'peticionRender'
                }
              },
              {
                title: 'Respuesta',
                dataIndex: 'response',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'respuestaRender'
                }
              },
              {
                title: 'Log',
                dataIndex: 'log',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'logRender'
                }
              },
              {title: 'Atributo 1', dataIndex: 'att_1', sorter: true},
              {title: 'Atributo 2', dataIndex: 'att_2', sorter: true},
              {title: 'Atributo 3', dataIndex: 'att_3', sorter: true},
              {title: 'Atributo 4', dataIndex: 'att_4', sorter: true},
              {title: 'Atributo 5', dataIndex: 'att_5', sorter: true},
              {title: 'Atributo 6', dataIndex: 'att_6', sorter: true},
              {title: 'Atributo 7', dataIndex: 'att_7', sorter: true},
              {title: 'Atributo 8', dataIndex: 'att_8', sorter: true},
              {title: 'Atributo 9', dataIndex: 'att_9', sorter: true},
              {title: 'Atributo 10', dataIndex: 'att_10', sorter: true},
              {title: 'Atributo 11', dataIndex: 'att_11', sorter: true},
              {title: 'Atributo 12', dataIndex: 'att_12', sorter: true},
              {title: 'Atributo 13', dataIndex: 'att_13', sorter: true},
              {title: 'Atributo 14', dataIndex: 'att_14', sorter: true},
              {title: 'Atributo 15', dataIndex: 'att_15', sorter: true},
              {title: 'Atributo 16', dataIndex: 'att_16', sorter: true},
              {title: 'Atributo 17', dataIndex: 'att_17', sorter: true},
              {title: 'Atributo 18', dataIndex: 'att_18', sorter: true},
              {title: 'Atributo 19', dataIndex: 'att_19', sorter: true},
              {title: 'Atributo 20', dataIndex: 'att_20', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado el', dataIndex: 'modified_on', sorter: true}
            ]
          },
          actions: [
            {
              name: 'actualizar',
              text: 'Actualizar',
              permisos: [],
              props: {icon: 'reload', type: 'primary'}
            }
          ]
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.cargarFormulariosGlobales()
    },
    methods: {
      cargarFormulariosGlobales () {
        this.loading = true
        this.httpClient.getInstance().get('action_groups/global_groups').then(response => {
          let newForm = {}
          response.data.map(group => {
            newForm[`r_${group.id}`] = {}
            if (JsUtils.isEmpty(this.activeForm)) {
              this.activeForm = group.id.toString()
            }
            group.colOptions = {xs: 24, sm: 24 / group.active_form.num_cols}
          })
          this.respuestas = {...newForm}
          this.setup = response.data
        })
          .catch(error => {
            Mensajes.error(this.$getErrorMessage(error, 'No fue posible cargar los formularios disponibles'))
            console.log(error)
          })
          .then(() => {
            this.loading = false
          })
      },
      validateForm () {
        let result = false
        let form = this.$refs[`r_${this.activeForm}_form`] && this.$refs[`r_${this.activeForm}_form`]
        if (!JsUtils.isEmpty(form)) {
          form[0].validate((valid) => {
            result = valid
          })
          if (!result) {
            Mensajes.error('Advertencia', 'Faltan campos que son requeridos por llenar.')
          }
        } else {
          Mensajes.error('Error interno', 'Referencia de formulario no encontrada.')
        }
        return result
      },
      masterActions (action) {
        switch (action.action) {
          case 'actualizar':
            this.$refs.masterComponent.$refs.datatable.loadData()
            break
          case 'reprogramar':
            this.$confirm({
              title: 'Confirmación',
              content: '¿Está seguro que desea continuar?',
              onOk: () => {
                this.reprogramar(action)
              },
              onCancel () {}
            })
            break
        }
      },
      reprogramar (action) {
        this.loadingBtns[action.record.id] = action.record.id
        this.loadingBtns = Object.assign({}, this.loadingBtns)
        this.httpClient.getInstance().post('async_job_execution/reprogramar/' + action.record.id)
          .then(response => {
            Mensajes.success('Correcto', 'Se reprogramó correctamente.')
            this.actualizarTabla()
          })
          .catch((error) => {
            Mensajes.error('Error', this.$getErrorMessage(error, 'No fue posible programar.'))
          })
          .then(() => {
            delete this.loadingBtns[action.record.id]
            this.loadingBtns = Object.assign({}, this.loadingBtns)
          })
      },
      recortarCadena (text) {
        if (!this.$isEmpty(text)) {
          if (text.length >= 19) {
            return text.substr(0, 19) + ' ...'
          } else {
            return text
          }
        } else {
          return text
        }
      },
      actualizarTabla () {
        this.$refs.masterComponent.$refs.datatable.loadData()
      },
      showHelp (group) {
        this.helpVisible['g' + group.id] = !this.helpVisible['g' + group.id]
        this.helpVisible = {...this.helpVisible}
      },
      verMas (text) {
        this.contenidoVerMas = text
        this.modalVerMas = true
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/GlobalForms/GlobalForms.vue